import { render, staticRenderFns } from "./SuccessTip.vue?vue&type=template&id=c6972566&scoped=true&"
import script from "./SuccessTip.vue?vue&type=script&lang=js&"
export * from "./SuccessTip.vue?vue&type=script&lang=js&"
import style0 from "./SuccessTip.vue?vue&type=style&index=0&id=c6972566&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6972566",
  null
  
)

export default component.exports